import { render, staticRenderFns } from "./eventDetails.vue?vue&type=template&id=71218705&"
import script from "./eventDetails.vue?vue&type=script&lang=js&"
export * from "./eventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports